// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2T7ER","footer":"Form_footer__19zbO"};